import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import axios from '@axios'
import router from './router'
import store from './store'
import App from './App.vue'
import { existsModule } from './hooks/modulesUtils'
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/vue-select'
import '@/libs/sweet-alerts'
import '@/libs/toastification'
import ability from './libs/acl/ability'
import Toast from 'vue-toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(Toast)

require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

localStorage.setItem("locale", i18n.locale)

Vue.prototype.$existsModule = existsModule

if (localStorage.getItem('userData')) {
    axios.post('refresh-data')
        .then(response => {
            localStorage.removeItem('userData')
            localStorage.setItem('userData', JSON.stringify(response.data))
            ability.update(response.data.ability)
        })
        .catch(error => {
            localStorage.removeItem('userData')
            location.reload()
        })
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')
